import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  createIntegrationConnectionsApi,
  useApiClient,
} from "@playbookai/api-clients";
import { useAuthStore } from "../../auth/auth-store.js";

export function useConnectionToolsApi() {
  const config = useApiClient();
  const api = useMemo(() => createIntegrationConnectionsApi(config), [config]);
  const claims = useAuthStore((s) => s.claims);
  const scope = [
    "connection-tool-settings",
    claims?.tenantId,
    claims?.userId,
  ] as const;
  return { api, scope };
}
export function useConnectionTools(connectionId: string) {
  const { api, scope } = useConnectionToolsApi();
  const queryKey = [...scope, "tools", connectionId];
  const query = useQuery({
    queryKey,
    queryFn: () => api.listEffectiveTools(connectionId),
    retry: false,
    refetchOnWindowFocus: true,
  });
  return { api, query, queryKey };
}

export function usePagedConnectionTools(
  connectionId: string,
  options: {
    readonly cursor?: string;
    readonly limit: 25 | 50;
    readonly query?: string;
  },
) {
  const { api, scope } = useConnectionToolsApi();
  const queryKey = [...scope, "tools-page", connectionId, options];
  const query = useQuery({
    queryKey,
    queryFn: () => api.pageEffectiveTools(connectionId, options),
    retry: false,
    refetchOnWindowFocus: true,
  });
  return { api, query, queryKey };
}
